<!-- 佣金记录 -->
<template>
  <div id="commission-page">
    <!-- header start -->
    <van-nav-bar
      title=""
      left-arrow
      :border="false"
      @click-left="goBack"
      :safe-area-inset-top="true"
      fixed
      :placeholder="true"
      :z-index="99"
    />
    <div class="commission-area-box">
      <img src="~@/assets/images/top-bg-2.png" alt="" class="bg" />
      <div class="profit-box">
        <div class="bd">
          <div class="check-date" @click="commissionDateShow = true">
            <div class="month">{{ month }}月</div>
            <div class="year">{{ year }}年</div>
            <van-icon name="arrow-down" size="12" color="#fff" />
          </div>
          <div class="profit-details-box" v-if="memberData!=null">
            <div class="thead">
              <img :src="memberData.HeadPic" alt="" class="avatar" />
              <div class="memeber-name">{{ memberData.NickName }}</div>
              <!-- <div class="grade-btn">老板</div> -->
            </div>
            <div class="profit-total">
              <div class="profit-total-tit">总业绩(元)</div>
              <div class="profit-total-price">{{ memberData.TotalPrice }}</div>
            </div>
            <div class="tuandui-box">
              <div class="turandui-item">
                团队：<span class="hlight">{{
                  memberData.MemberCount == -1 ? 0 : memberData.MemberCount
                }}</span
                >人
              </div>
              <div class="turandui-item">直属代理</div>
            </div>
          </div>
        </div>
      </div>

      <div class="daili-box">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            :offset="offset"
            finished-text="没有更多了"
            @load="loadMore"
          >
            <div
              class="daili-item van-hairline--bottom"
              v-for="(item, i) in dataList"
              :key="i"
            >
              <div class="th">
                <img :src="item.HeadPic" alt="" class="avatar" />
              </div>
              <div class="bd">
                <div class="thead">
                  <div class="flexmid flexbox van-ellipsis">
                    <div class="member-name">{{ item.NickName }}</div>
                    <div class="tuandui-num">
                      团队：<span class="hlight">{{ item.MemberCount }}</span
                      >人
                    </div>
                  </div>
                  <div class="grade-btn">直属代理</div>
                </div>
                <div class="tbody">
                  <!-- <div class="yeji-item">
                  <div class="yeji-tit">个人业绩</div>
                  <div class="yeji-num">4500.00</div>
                </div> -->
                  <div class="yeji-item">
                    <div class="yeji-tit">团队业绩</div>
                    <div class="yeji-num">{{ item.TotalPrice }}</div>
                  </div>
                </div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>

    <!-- 日期 popup start -->
    <van-popup v-model="commissionDateShow" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        title="选择年月"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="commissionDateShow = false"
        @cancel="commissionDateShow = false"
        @change="commissionDateChange"
      />
    </van-popup>
    <!-- 日期 popup end -->
  </div>
</template>

<script>
import common from "../../tools/common";
import { DatetimePicker } from "vant";

export default {
  data() {
    return {
      tabActive: 0,
      minDate: new Date(2019, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      commissionDateShow: false,
      options: {
        type: "GetBossCommissionSearch",
        PageIndex: 1,
        memberId: this.$route.query.MemberId,
      },
      option2s: {
        type: "GetBossSumCommission",
        memberId: this.$route.query.MemberId,
      },

      offset: 100,
      refreshing: false,
      loading: true,
      finished: false,
      dataList: [],
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      memberData: null,
    };
  },
  components: {
    [DatetimePicker.name]: DatetimePicker,
  },
  methods: {
    init() {
      Object.assign(this.options, {
        PageIndex: 1,
        year: this.year,
        month: this.month,
      });
      Object.assign(this.option2s, {
        year: this.year,
        month: this.month,
      });
      this.GetBossSumCommission();
      this.getList();
    },
    GetBossSumCommission() {
      var that = this;
      this.$store.dispatch(this.option2s).then((res) => {
        common.Response.callNotMsgResponse(res, (result) => {
          //console.log(result);
          that.memberData = result;
        });
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    goCommissionPage() {
      this.$router.push("/commissionDetails");
    },
    goChild(mid) {
      this.$router.push("/memberDetails?MemberId=" + mid);
    },
    commissionDateChange(picker, value, index) {
      let dateArray = picker.getValues();
      this.year = dateArray[0];
      this.month = dateArray[1];
      this.init();
      //console.log(dateArray);
      //this.commissionDate = dateArray.join("-");
    },

    onRefresh() {
      this.finished = false;
      this.loading = true;
      Object.assign(this.options, {
        PageIndex: 1,
      });
      this.getList();
    },
    loadMore() {
      Object.assign(this.options, {
        PageIndex: this.options.PageIndex + 1,
      });
      this.loading = true;
      this.getList();
    },
    getList() {
      var that = this;
      this.$store.dispatch(this.options).then(
        (res) => {
          that.loading = false;
          if (that.refreshing) {
            that.refreshing = false;
          }
          common.Response.callNotMsgResponse(res, function(result) {
            //console.log(result);
            if (result.data.length <= 0) {
              that.finished = true;
            }
            if (that.options.PageIndex > 1) {
              if (result.data.length > 0) {
                result.data.forEach((element) => {
                  that.dataList.push(element);
                });
              }
            } else {
              that.dataList = result.data;
            }
          });
        },
        (error) => {
          console.log(error);
        }
      );
    },
  },
  created() {
    this.init();
  },
};
</script>
<style lang="less" scoped>
.commission-area-box {
  width: 100%;
  height: auto;
  padding-bottom: 10.5px;
  position: relative;
}

.commission-area-box > .bg {
  width: 100%;
  display: block;
  position: absolute;
  top: 0;
  background-size: 100% 100%;
  height: 115px;
}
.grade-btn {
  margin-left: 15px;
  line-height: 1;
  font-size: 10px;
  color: #f6ae33;
  border: 1px solid;
  width: 68px;
  padding: 4px 0;
  text-align: center;
  border-radius: 999px;
}
.profit-box {
  position: relative;
  margin: 0 16px 16px;
  .bd {
    .check-date {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      justify-content: flex-end;
      .month {
        font-size: 15px;
        color: #fff;
      }
      .year {
        margin-left: 12px;
        font-size: 12px;
        color: #fff;
        margin-right: 6px;
      }
    }
    //佣金详情
    .profit-details-box {
      background: #fff;
      border-radius: 6px;
      padding: 12px 14px;
      .thead {
        display: flex;
        align-items: center;
        position: relative;
        .avatar {
          width: 65px;
          height: 65px;
          object-fit: cover;
          border-radius: 50%;
          margin-right: 12px;
          border: 3px solid #fff;
          position: relative;
          margin-top: -36px;
          margin-left: -14px;
        }
        .memeber-name {
          font-size: 14px;
          color: #000;
          flex: 1;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .profit-total {
        text-align: center;
        margin-top: 20px;
        margin-bottom: 25px;
        .profit-total-tit {
          font-size: 10px;
          color: #1d1d1d;
        }
        .profit-total-price {
          font-size: 21px;
          color: #ff565c;
          margin-top: 10px;
        }
      }
      .tuandui-box {
        display: flex;
        align-items: center;
        .turandui-item {
          flex: 1;
          position: relative;
          font-size: 12px;
          color: #393939;
          padding: 0 15px;
          text-align: center;
          .hlight {
            color: #ff0030;
          }
          &:first-child:after {
            content: "";
            position: absolute;
            top: 50%;
            right: 0;
            width: 2px;
            height: 12px;
            margin-top: -6px;
            background: #555;
            border-radius: 999px;
          }
        }
      }
    }
  }
}
//佣金记录-下级用户
.daili-box {
  margin: 10px;
  background: #fff;
  border-radius: 6px;
  padding: 12px 16px;
}
.daili-item {
  display: flex;
  padding: 15px 0;
  .th {
    margin-right: 12px;
    .avatar {
      width: 52px;
      height: 52px;
      object-fit: cover;
      border-radius: 50%;
    }
  }
  .bd {
    flex: 1;
    overflow: hidden;
    .thead {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .member-name {
        font-size: 14px;
        color: #000;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .tuandui-num {
        margin-left: 15px;
        font-size: 12px;
        color: #666;
        flex-shrink: 0;
        .hlight {
          color: #ff565c;
        }
      }
      .grade-btn {
        // align-content: flex-end;
      }
    }
    .tbody {
      margin-top: 10px;
      display: flex;
      align-items: center;
      .yeji-item {
        flex: 1;
        overflow: hidden;
        .yeji-tit {
          font-size: 10px;
          color: #ababab;
        }
        .yeji-num {
          font-size: 13px;
          color: #ff565c;
          margin-top: 4px;
        }
      }
    }
  }
}
</style>
<style lang="less">
#commission-page {
  .van-nav-bar {
    background-image: url("~@/assets/images/top-bg-1.png");
    background-size: 100% 100%;
  }
  .van-nav-bar .van-icon {
    color: #fff;
    font-size: 20px;
  }
  .van-nav-bar__title {
    color: #fff;
  }
}
</style>
